import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  stationCoverageZones: [],
  allStationCoverageZones: [],
  allStationCoverageZonesOfAllStations: [],
  totalPages: 0,
  totalRecords: 0,
  stationCoverageZone: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_94: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_StationCoverageZones(state, stationCoverageZones) {
    state.stationCoverageZones = stationCoverageZones.items;
    state.totalPages = stationCoverageZones.totalPages;
    state.totalRecords = stationCoverageZones?.totalRecords ?? 0;
  },
  SET_AllStationCoverageZones(state, stationCoverageZones) {
    state.allStationCoverageZones = stationCoverageZones;
  },
  SET_StationCoverageZone(state, stationCoverageZone) {
    state.stationCoverageZone = stationCoverageZone;
  },
  SET_AllStationCoverageZonesWithOutId(state, stationCoverageZone) {
    state.allStationCoverageZonesOfAllStations = stationCoverageZone;
  },
};
const actions = {
  errorStationCoverageZone({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllStationCoverageZones({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/StationCoverageZones/All?stationId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllStationCoverageZones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationCoverageZone', error);
      });
  },
  getAllStationCoverageZonesWithOutId({ commit, dispatch, rootState }) {
    return apiClient
      .get('/StationCoverageZones/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllStationCoverageZonesWithOutId', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationCoverageZone', error);
      });
  },
  addStationCoverageZone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/StationCoverageZones', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationCoverageZone', error);
      });
  },
  getStationCoverageZone({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/StationCoverageZones/ById?stationCoverageZoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_StationCoverageZone', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationCoverageZone', error);
      });
  },
  editStationCoverageZone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/StationCoverageZones/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationCoverageZone', error);
      });
  },
  deleteStationCoverageZone({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/StationCoverageZones/Remove?stationCoverageZoneId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorStationCoverageZone', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
